/*
 * ds-rail.js — стрелки горизонтальной ленты.
 *
 * Один и тот же паттерн у ленты «Скидка месяца» на «Акциях» и у галереи зала
 * на странице магазина, поэтому логика общая, а размеры кадров — за CSS
 * конкретной страницы. Лента листается на два элемента за нажатие.
 *
 * Разметка:
 *   <div data-ds-rail> … </div>
 *   <button data-ds-rail-prev> <button data-ds-rail-next>
 * Стрелки ищутся внутри той же секции. На мобильном они скрыты CSS — там
 * лента листается пальцем, и скрипт ничего не делает.
 *
 * Инициализация идемпотентна: лента помечается data-ds-rail-ready.
 */

(function () {
  if (window.dsRail) return;
  window.dsRail = true;

  function railStep(rail) {
    var item = rail.firstElementChild;
    if (!item) return rail.clientWidth;
    var gap = parseInt(window.getComputedStyle(rail).columnGap, 10) || 0;
    return (item.offsetWidth + gap) * 2;
  }

  function syncArrows(rail, prev, next) {
    /* В RTL scrollLeft уходит в минус, поэтому сравниваем по модулю. */
    var position = Math.abs(rail.scrollLeft);
    var max = rail.scrollWidth - rail.clientWidth - 1;
    if (prev) prev.disabled = position <= 1;
    if (next) next.disabled = position >= max;
  }

  function initRail(rail) {
    if (rail.hasAttribute('data-ds-rail-ready')) return;
    rail.setAttribute('data-ds-rail-ready', '');

    var scope = rail.closest('section') || document;
    var prev = scope.querySelector('[data-ds-rail-prev]');
    var next = scope.querySelector('[data-ds-rail-next]');
    if (!prev && !next) return;

    var direction = window.getComputedStyle(rail).direction === 'rtl' ? -1 : 1;

    function scrollByStep(sign) {
      rail.scrollBy({ left: sign * direction * railStep(rail), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
    if (next) next.addEventListener('click', function () { scrollByStep(1); });

    rail.addEventListener('scroll', function () {
      syncArrows(rail, prev, next);
    }, { passive: true });

    syncArrows(rail, prev, next);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ds-rail]'), initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme Editor перерисовывает секцию целиком — инициализируем новую ленту. */
  document.addEventListener('shopify:section:load', init);
})();
